import { render, staticRenderFns } from "./AssignmentForm.vue?vue&type=template&id=9fe7c90a&scoped=true&"
import script from "./AssignmentForm.vue?vue&type=script&lang=js&"
export * from "./AssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe7c90a",
  null
  
)

export default component.exports